import { render, staticRenderFns } from "./SkillsOrderSelect.vue?vue&type=template&id=635b6a06&scoped=true&"
import script from "./SkillsOrderSelect.vue?vue&type=script&lang=js&"
export * from "./SkillsOrderSelect.vue?vue&type=script&lang=js&"
import style0 from "./SkillsOrderSelect.vue?vue&type=style&index=0&id=635b6a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635b6a06",
  null
  
)

export default component.exports